let audioCtx = null;
let muted = localStorage.getItem('golf_muted') === 'true';
let userHasInteracted = false;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function isMuted() {
  return muted;
}

function setMuted(val) {
  muted = val;
  localStorage.setItem('golf_muted', val ? 'true' : 'false');
}

function toggleMute() {
  setMuted(!muted);
  return muted;
}

function markInteracted() {
  userHasInteracted = true;
}

function canPlay() {
  return !muted && userHasInteracted;
}

function playTrumpet() {
  if (!canPlay()) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    [
      { freq: 523, start: 0, dur: 0.15 },
      { freq: 659, start: 0.15, dur: 0.15 },
      { freq: 784, start: 0.3, dur: 0.15 },
      { freq: 1047, start: 0.45, dur: 0.4 },
    ].forEach(({ freq, start, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.12, now + start + 0.03);
      gain.gain.linearRampToValueAtTime(0.08, now + start + dur * 0.5);
      gain.gain.linearRampToValueAtTime(0, now + start + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + dur);
    });
  } catch {}
}

function playChirp() {
  if (!canPlay()) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    [0, 0.12].forEach((offset) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(1200, now + offset);
      osc.frequency.linearRampToValueAtTime(1600, now + offset + 0.06);
      gain.gain.setValueAtTime(0, now + offset);
      gain.gain.linearRampToValueAtTime(0.1, now + offset + 0.015);
      gain.gain.linearRampToValueAtTime(0, now + offset + 0.08);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + offset);
      osc.stop(now + offset + 0.1);
    });
  } catch {}
}

function playColumnMatch() {
  if (!canPlay()) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    [880, 1108, 1320].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const start = i * 0.08;
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.1, now + start + 0.02);
      gain.gain.linearRampToValueAtTime(0, now + start + 0.25);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + 0.3);
    });
  } catch {}
}

function playGoodSwap() {
  if (!canPlay()) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(600, now);
    osc.frequency.linearRampToValueAtTime(900, now + 0.12);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.08, now + 0.02);
    gain.gain.linearRampToValueAtTime(0, now + 0.15);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.2);
  } catch {}
}

function playVictoryFanfare() {
  if (!canPlay()) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    [
      { freq: 523, start: 0, dur: 0.12 },
      { freq: 659, start: 0.12, dur: 0.12 },
      { freq: 784, start: 0.24, dur: 0.12 },
      { freq: 1047, start: 0.36, dur: 0.2 },
      { freq: 784, start: 0.56, dur: 0.1 },
      { freq: 1047, start: 0.66, dur: 0.5 },
    ].forEach(({ freq, start, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.1, now + start + 0.02);
      gain.gain.linearRampToValueAtTime(0.07, now + start + dur * 0.6);
      gain.gain.linearRampToValueAtTime(0, now + start + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + dur);
    });
  } catch {}
}

export {
  playTrumpet,
  playChirp,
  playColumnMatch,
  playGoodSwap,
  playVictoryFanfare,
  isMuted,
  setMuted,
  toggleMute,
  markInteracted,
};
